import React, { useEffect } from "react";
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import Footer from "../../components/common/Footer";
import Header from "../../components/common/header/Header";
import { useState, useRef } from "react";
import { union, reduce, result, indexOf, concat, countBy, filter, forEach } from "lodash";
import EventItem from "../../components/em/EventItem"
import {isMobileOnly} from 'react-device-detect';
import { getCampaignListAction, getCampaignListAddAction, setEventMainTabIndexAction } from '../../modules/campaign/campaignModule';
import { useHistory } from 'react-router-dom';

const EventMainBlock = styled.div``;

const EventContentsBlock = styled.div`
    max-width: 1176px;
    ${isMobileOnly?`
        margin: 0 4vw;
    `:`
        width: 100%;
        margin: 0 auto;
    `};
    padding-top: 80px
`;

const EventContentContainerBlock = styled.div`
    padding: 30px 0 120px;
`;

const EventContainerBlock = styled.div`
    ${isMobileOnly?`
    padding-top: 60px;   
  `:`
    padding-top: 80px;
  `};
`;

const EventTabUlBlock = styled.ul`
`;

const EventTabLiBlock = styled.li`

`;

const EventTabButtonBlock = styled.button`
    color: ${props => props.colorf};
`;

const EventItemContinerBlock = styled.div``;

const EventItemListUlBlock = styled.ul`
/*JP*/
    display: flex;
    flex-wrap: wrap;
    justify-content: ${isMobileOnly?'space-between':'flex-start'};
/*JP*/    
    ${isMobileOnly?"margin-left:0":"margin-left: -30px"};
    //margin-bottom: 80px;
    margin-top: 30px;
    ::-webkit-scrollbar {
        width: 4px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 5px;
    }

    ::-webkit-scrollbar-track {
        background-color: #f4f4f4;
    }

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const EventItemNoItemBloc = styled.div`
    position: relative;
    height: 180px;
    width: 100%;
`;

const EventItemNoItemSpanBlock = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #666;
    font-size: 16px;
`;

const EventMoreBlock = styled.p`
    text-align: center;
    height: 64px;
`;

const EventMoreBtnBlock = styled.button`
    text-align: center;
    text-decoration: underline;
`;

const EventListUlBlock = styled.ul`
`;

const Options = [
    { value: 0, label: "전체" },
    { value: 1, label: "프로모션" },
    { value: 2, label: "세일" },
    { value: 3, label: "브랜드" },
    { value: 4, label: "가이드" },
];

const LIMIT_COUNT = 9;
const EventMain = () => {
    const dispatch = useDispatch();
    //const [curTabIndex, setCurTabIndex] = useState(0);
    const history = useHistory();

    const { campaignList, curMenu,curTabIndex } = useSelector(
            ({ campaignReducer, headerReducer }) => ({
                campaignList: campaignReducer.campaignList,
                curMenu: headerReducer.curMenu,
                curTabIndex: campaignReducer.curTabIndex,
            })
        );

        useEffect(() => {

            if (curMenu !== 'em') {
                window.scrollTo(0, 0);
                dispatch(setCurMenuAction('em'));
                dispatch(setHeaderTransferAction(false));
            }

            if(history.action === 'PUSH' || campaignList === null){
                let param = "?type="+Options[0].value+"&offset=0&limit=" + LIMIT_COUNT;
                dispatch(getCampaignListAction(param));
            }

        }, []);

    const handleTabButton = (index) => {

        //setCurTabIndex(index);
        dispatch(setEventMainTabIndexAction(index));

        let param = "?type="+index+"&offset=0&limit=" + LIMIT_COUNT;
        dispatch(getCampaignListAction(param));
    }

    const isMoreBtnShow = () => {
        if (campaignList === null ||
            campaignList === undefined ||
            campaignList.count === null ) {
            return false;
        }

        let count = 0;
        if(curTabIndex === 0) {
            count = campaignList.count.total;
        } else if(curTabIndex === 1) {
            count = campaignList.count.promo;
        } else if(curTabIndex === 2) {
            count = campaignList.count.sale;
        } else if(curTabIndex === 3) {
            count = campaignList.count.brand;
        }

        if(campaignList.event !== null && count > campaignList.event.length){
            return true;
        }

        return false;
    }

    const handlerMoerClick = () => {
        let off = campaignList.event.length;

        let param = "?type="+curTabIndex+"&offset="+ off +"&limit=" + LIMIT_COUNT;
        console.log("param = " + param)
        dispatch(getCampaignListAddAction(param));
    }
//console.log("campaignList = " + campaignList)
    if(campaignList === null || campaignList === undefined){
        return <div/>
    }
    return (
        <EventMainBlock>
            <Header />
            <EventContentsBlock>
                <EventContentContainerBlock>
                    <div className="filter-top clearfix" style = {isMobileOnly? {width:'100%', overflowX: 'scroll', overflowY: 'hidden', position:'relative'}:{}}>
                        <EventTabUlBlock className="tab-list f-left clearfix" style = {isMobileOnly? {width:'max-content'}:{}} >
                            {
                                Options.map((item, index) => {
                                    return (
                                        <EventTabLiBlock key={item.value} className={curTabIndex === index ? "active" : ""}
                                        style = {isMobileOnly? {padding:'20px 2vw',display: 'flex',height: '100%',justifyContent: 'center'}:{}}>
                                            <EventTabButtonBlock className="green_border" onClick={() => handleTabButton(item.value)}
                                                colorf={curTabIndex === index ? "#111" : "#999"}>
                                                {item.label}
                                            </EventTabButtonBlock>
                                        </EventTabLiBlock>
                                    );
                                })
                            }
                        </EventTabUlBlock>
                    </div>
                    <EventItemContinerBlock>
                        <EventItemListUlBlock>
                        {
                        campaignList.event === null ?
                            <EventItemNoItemBloc><EventItemNoItemSpanBlock>이벤트 정보가 없습니다.</EventItemNoItemSpanBlock></EventItemNoItemBloc>
                        :
                            // 상품 리스트 표시
                            campaignList.event.map((item) => {
                                return (
                                    <EventItem key={item.ev_id}
                                        info = {item} />
                                )
                            }
                            )
                        }
                        </EventItemListUlBlock>
                        {isMoreBtnShow() ?
                            <EventMoreBlock>
                                <EventMoreBtnBlock onClick={handlerMoerClick}>더보기
                                </EventMoreBtnBlock>
                            </EventMoreBlock> : ''
                        }
                    </EventItemContinerBlock>
                    {/* <FaqListUlBlock className="qna-acco margin_b-40">
                        {
                            listData.dataList.map((dataInfo, index) => {
                                if (dataInfo.id === curSelId && fromFooter === true) {
                                    setItemIndex(index);
                                    setFromFooter(false);
                                }
                                return <FaqAccoItem key={dataInfo.id.toString() + CateOption[curTabIndex].value} dataInfo={dataInfo}
                                    clickHandler={handleAccBtn}
                                    active={dataInfo.id === curSelId} />
                            })
                        }
                    </FaqListUlBlock> */}

                </EventContentContainerBlock>
            </EventContentsBlock>
            <Footer />
        </EventMainBlock>
    );
};

export default EventMain;
